import React, {useCallback, useEffect, useRef, useState} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {Helmet} from 'react-helmet';
import {logPageLoadEvents} from '@ibibo/analytics';
import {perfUtils} from '@ibibo/hotel-utils';
import {gaConfig} from '@ibibo/hotels-config';

import * as S from './SRP.styles';
import {fetchSrpDataThunk} from './redux/thunks';
import {resetFilterAction} from './redux/actions';
import {hasDataSelectorFn, isSrpLoadingSelectorFn, cityMetaInfoSelectorFn, commonSelector} from './redux/selectors';
import Filters from './containers/Filters/Filters';
import HotelList from './containers/HotelList';
import SearchWidget from './containers/SearchWidget';
import {sendEvarData} from '@ibibo/analytics';

import SmartEngageApiContainer from '../SmartEngage/SmartEngageApiContainer';
import GoSafeCardBlock from '../SmartEngage/containers/GoSafeCardBlock';

import SRPHeader from '../../../stories/components/hotels/SRP/SRPHeader/SRPHeader';
import PopularitySort from '../../../stories/components/hotels/SRP/PopularitySort/PopularitySort';
import ShareHotelProperties from '../ShareHotel/containers/ShareProperties';
// import TopInfoBlock from '../../../stories/components/hotels/SRP/TopInfoBlock/TopInfoBlock';

import {updateShareHotelList} from '../ShareHotel/redux/actions';
import {shareHotelListSelector} from '../ShareHotel/redux/selectors';
import {userSettingDataSelector} from '@ibibo/myaccount-reducer';


function getFormatDate(date) {
  var d = date.date.getDate();
  var m = date.date.getMonth() + 1;
  var y = date.date.getFullYear();
  return (d <= 9 ? '0' + d : d) + ':' + (m<=9 ? '0' + m : m) + ':' + y;
}

function formatRoomString(roomString) {
  var parts = roomString.split("-")
  return `mypartner:${parts[1]}A|${parts[2]}C|0I|${parseInt(parts[1]) + parseInt(parts[2])}`
}

const SRP = () => {
  const dispatch = useDispatch();

  const hasData = useSelector(hasDataSelectorFn);
  const isLoading = useSelector(isSrpLoadingSelectorFn);
  const cityData = useSelector(cityMetaInfoSelectorFn);
  const shareHotelsList = useSelector(shareHotelListSelector);
  const userData = useSelector(userSettingDataSelector);
  const { account_id } = userData;
  const common = useSelector(commonSelector);
  const { checkin, checkout, destination, country } = common;

  const hasGAFired = useRef(false);

  const [isDisabled, setIsDisabled] = useState(false);

  const fetchSrpDataThunkCaller = useCallback((arg: boolean) => {
    dispatch(fetchSrpDataThunk(arg));
  }, []);
  
  useEffect(() => {
    if(shareHotelsList){
      var size = Object.keys(shareHotelsList).length;
      if(size >= 10){
        setIsDisabled(true);
      }else{
        setIsDisabled(false);
      }
    }
    
    if(!shareHotelsList)
    {
      setIsDisabled(false);
    }
  }, [shareHotelsList]);
  

  const saveShareHotelDataCaller = useCallback((data) => {
    dispatch(updateShareHotelList(data));
  }, []);

  useEffect(() => {
    if (!hasGAFired.current)
      perfUtils.markPerformanceStart(gaConfig.SrpGAEvents.performanceMarkers.start);
    if (hasData === null && !isLoading) {
      fetchSrpDataThunkCaller(false);
    }
    return () => {
      dispatch(resetFilterAction());
    };
  }, []);

  useEffect(() => {
    if(account_id && hasData) {
      var date_today = new Date();
      var diff = Math.abs(checkin.date.getTime() - date_today.getTime());
      var diffDays = Math.ceil(diff / (1000 * 3600 * 24));
      let searchType = '';
      if(cityData.co !== 'india'){
        searchType = 'intl';
      }else{
        searchType = 'domestic';
      }

      sendEvarData({
        prop3: `|${destination.n}`,
        prop24: `${country === "india" ? "domestic" : "international"} hotels|mypartner`,
        eVar24: "D=c24",
        eVar37: "domain_sbu:india|domain_country:in|domain_currency:inr|domain_language:eng",
        eVar3: "D=c3",
        eVar4: "D=c4",
        eVar5: "D=c5",
        eVar7: "D=c7",
        eVar67: account_id.value,
        prop4: getFormatDate(checkin),
        prop5: getFormatDate(checkout),
        prop7: diffDays,
        eVar11: "D=c11",
        prop11: formatRoomString(common.roomString),
      }, false, {pageName: `funnel:${searchType} hotels:listing|mypartner`})
    }
  }, [hasData])

  useEffect(() => {
    if (!hasGAFired.current && hasData) {
      hasGAFired.current = true;
    }
  }, [hasData]);

  const linkArray = [
    {
      rel: 'canonical',
      href: 'https://mypartner.makemytrip.com/hotels/',
    },
  ];

  return (
    <>
      <Helmet
        title="myPartner - Hotel Listing"
        meta={[{name: 'robots', content: 'noindex, nofollow'}]}
        link={linkArray}
      />
      <SearchWidget isSrp />
      <SmartEngageApiContainer page="SRP" />
      <S.SrpMainWrapper>
        {/* {hasData !== null && (
          <S.MainSectionWrapper>
            <NavigationHeader />
          </S.MainSectionWrapper> 
        )} */}
        <S.SrpMainInnerWrapper>
          <S.LeftSectionWrapperStyle>
            {/* <OfferWidget /> */}
            <SRPHeader />
            <Filters cityData={cityData} />
          </S.LeftSectionWrapperStyle>
          <S.RightSectionWrapperStyle>
            <GoSafeCardBlock ContainerWrapper={S.GoSafeCardBlockWrapper} />
            <PopularitySort />
            {/* <TopInfoBlock /> */}
            <HotelList fetchMoreFn={fetchSrpDataThunkCaller} updateShareHotelList={saveShareHotelDataCaller} shareHotelsList={shareHotelsList} shareDisabled={isDisabled} />
          </S.RightSectionWrapperStyle>
        </S.SrpMainInnerWrapper>
        <ShareHotelProperties />
      </S.SrpMainWrapper>
    </>
  );
};

export default SRP;